import { render, staticRenderFns } from "./uploadCert.vue?vue&type=template&id=695f13d0&"
import script from "./uploadCert.vue?vue&type=script&lang=js&"
export * from "./uploadCert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports